var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495 495",
    style: {
      enableBackground: "new 0 0 495 495"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M142.11,222.098l-56.258,56.257c12.345,5.919,22.365,15.939,28.284,28.285l56.258-56.257 C158.049,244.463,148.03,234.444,142.11,222.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M272.903,244.618l-22.519-22.519c-5.919,12.346-15.939,22.365-28.284,28.284l22.519,22.52 C250.538,260.557,260.557,250.538,272.903,244.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9BC9FF"
    },
    d: "M380.863,188.36l-56.257,56.257c12.346,5.919,22.365,15.939,28.285,28.284l56.257-56.257 C396.802,210.726,386.783,200.706,380.863,188.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M0,332.491c0,33.084,26.916,60,60,60v-120C26.916,272.491,0,299.407,0,332.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M375,162.509c0,9.251,2.108,18.019,5.863,25.852c5.919,12.346,15.939,22.365,28.285,28.285 c7.833,3.756,16.601,5.864,25.852,5.864v-120C401.916,102.509,375,129.425,375,162.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M136.247,196.247c0,9.251,2.108,18.019,5.863,25.852c5.919,12.346,15.938,22.365,28.284,28.284 c7.833,3.756,16.601,5.864,25.853,5.864v-120C163.163,136.247,136.247,163.163,136.247,196.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2488FF"
    },
    d: "M272.903,244.618c-12.346,5.92-22.365,15.939-28.284,28.285c-3.756,7.833-5.863,16.6-5.863,25.852 c0,33.084,26.916,60,60,60v-120C289.503,238.754,280.736,240.862,272.903,244.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M85.853,278.355c-7.833-3.756-16.601-5.864-25.853-5.864v120c33.084,0,60-26.916,60-60 c0-9.251-2.108-18.018-5.863-25.851C108.218,294.294,98.198,284.275,85.853,278.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M435,102.509v120c33.084,0,60-26.916,60-60S468.084,102.509,435,102.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M250.383,222.099c3.756-7.833,5.864-16.601,5.864-25.852c0-33.084-26.916-60-60-60v120 c9.251,0,18.019-2.108,25.852-5.864C234.445,244.464,244.464,234.445,250.383,222.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005ECE"
    },
    d: "M324.606,244.618c-7.833-3.756-16.6-5.863-25.852-5.863v120c33.084,0,60-26.916,60-60 c0-9.251-2.108-18.019-5.864-25.852C346.972,260.556,336.952,250.537,324.606,244.618z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphSvgrepoCom);
export default __webpack_public_path__ + "static/media/graph-svgrepo-com.d361ac9c0f3ddcba0e04a5604ea1c8dc.svg";
export { ForwardRef as ReactComponent };